// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/more-horizontal.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function MoreHorizontalIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M2.25 6.625C3.00939 6.625 3.625 7.24061 3.625 8C3.625 8.75939 3.00939 9.375 2.25 9.375C1.49061 9.375 0.875 8.75939 0.875 8C0.875 7.24061 1.49061 6.625 2.25 6.625ZM8 6.625C8.75939 6.625 9.375 7.24061 9.375 8C9.375 8.75939 8.75939 9.375 8 9.375C7.24061 9.375 6.625 8.75939 6.625 8C6.625 7.24061 7.24061 6.625 8 6.625ZM13.75 6.625C14.5094 6.625 15.125 7.24061 15.125 8C15.125 8.75939 14.5094 9.375 13.75 9.375C12.9906 9.375 12.375 8.75939 12.375 8C12.375 7.24061 12.9906 6.625 13.75 6.625Z"
				fill="currentColor"
			/>
		</IconBase>
	);
}
